<template id="countdown-template">
  <div class="countdown">
    <p class="digit" :style="{ color: color }" v-if="showLabel">Finalize em até</p>
    <p class="digit" :style="{ color: color }">{{ minutes | two_digits }}:{{ seconds | two_digits }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'white',
    },
    date: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    window.setInterval(() => {
      this.now = Math.trunc(new Date() / 1000);
    }, 1000);
  },
  data() {
    return {
      now: Math.trunc(new Date() / 1000),
    };
  },
  computed: {
    ...mapGetters(['secure3dsOpen']),

    dateInMilliseconds() {
      return this.date / 1000;
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    },
  },
  watch: {
    now(value) {
      console.log(this.secure3dsOpen)
      if (this.now > this.dateInMilliseconds && this.dateInMilliseconds !== 0 && !this.secure3dsOpen) {
        this.$store.dispatch('setExpirationDialog', true);
      }
    },
  },
};
</script>

<style scoped>
.countdown {
  display: flex;
}

.digit {
  margin: 2px;
}
</style>
